import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

function CoverLetterProgress({ step }) {
  return (
    <Row className="justify-content-center mb-4">
      <Col xs={12} md={8}>
        <div className="d-flex justify-content-between align-items-center position-relative">
          {[
            { num: 1, label: 'Twoje dane' },
            { num: 2, label: 'Pracodawca' },
            { num: 3, label: 'Zawód' },
            { num: 4, label: 'Podgląd' }
          ].map((s, index) => (
            <React.Fragment key={s.num}>
              <div className="text-center" style={{ zIndex: 2, flex: 1 }}>
                <div
                  className="mx-auto mb-2 d-flex align-items-center justify-content-center"
                  style={{
                    width: window.innerWidth >= 768 ? '50px' : '40px',
                    height: window.innerWidth >= 768 ? '50px' : '40px',
                    borderRadius: '50%',
                    background: step >= s.num ? '#ffc107' : 'rgba(255,255,255,0.1)',
                    border: step >= s.num ? 'none' : '2px solid rgba(255,255,255,0.3)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {step > s.num ? (
                    <FaCheckCircle 
                      size={window.innerWidth >= 768 ? 24 : 18} 
                      className="text-white" 
                    />
                  ) : (
                    <span 
                      className="text-white fw-bold"
                      style={{ fontSize: window.innerWidth >= 768 ? '1rem' : '0.85rem' }}
                    >
                      {s.num}
                    </span>
                  )}
                </div>
                <small 
                  className="text-white-50 d-none d-md-block"
                  style={{ fontSize: '0.75rem' }}
                >
                  {s.label}
                </small>
              </div>
              {index < 3 && (
                <div
                  style={{
                    flex: 2,
                    height: '3px',
                    background: step > s.num ? '#ffc107' : 'rgba(255,255,255,0.1)',
                    transition: 'all 0.3s ease',
                    marginBottom: window.innerWidth >= 768 ? '2rem' : '1.5rem'
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </Col>
    </Row>
  );
}

export default CoverLetterProgress;